import { Request } from "express";

import { IParamBinder } from "./IParamBinder";

export class StringBodyParamBinder implements IParamBinder {
    public extractValue(req: Request): unknown {
        if (!(req.body instanceof Buffer)) {
            return undefined;
        }
        return req.body.toString();
    }
}
